import { render, staticRenderFns } from "./sn_register.vue?vue&type=template&id=34b6197a"
import script from "./sn_register.vue?vue&type=script&lang=js"
export * from "./sn_register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports